// extracted by mini-css-extract-plugin
export default {"Alumni":"AlumniDark_Alumni__B-tf4"};